import { Stat } from '@Common/models';

export const GLOBAL_CONSTANTS = Object.freeze({
  CTRL_ENTER: ' (Ctrl + Enter)',
  CMD_ENTER: ' (Cmd + Return)',
});

export const GRAMMAR_STATS = Object.freeze<Stat[]>([
  {
    key: 'totalErrors',
    name: 'TOTAL ERRORS',
    type: 'singleValue',
  },
  {
    key: 'errorPercentage',
    name: 'ERROR PERCENTAGE',
    type: 'singleValue',
    tooltipText: 'Number of errors per 100 words.',
  },
  {
    key: 'readingTime',
    name: 'READING TIME',
    type: 'singleValue',
  },
  {
    key: 'readability',
    name: 'READABILITY',
    type: 'singleValue',
    tooltipText: 'The Flesch Reading Ease Formula is the score we use to define readability.',
  },
  {
    key: 'sentiment',
    name: 'SENTIMENT',
    type: 'singleValue',
  },
]);

export const SUMMARIZER_STATS = Object.freeze<Stat[]>([
  {
    key: 'words',
    name: 'WORD COUNT',
    type: 'multiValue',
  },
  {
    key: 'sentences',
    name: 'SENTENCE COUNT',
    type: 'multiValue',
  },
  {
    key: 'characters',
    name: 'CHARACTERS',
    type: 'multiValue',
  },
  {
    key: 'reduction',
    name: 'REDUCTION',
    type: 'singleValue',
  },
]);

export const GC_STAT_DRAWER_DEFAULT_TEXT = 'Please enter some text to view statistics.';
export const SMZR_STAT_DRAWER_DEFAULT_TEXT =
  'Please enter some text and click the Summarize button to view statistics.';
export const PPHR_STAT_DRAWER_DEFAULT_TEXT =
  'Please enter some text and click the Paraphrase button to view statistics.';
